import { render, staticRenderFns } from "./sidebar-item-menu.vue?vue&type=template&id=264ca18f&scoped=true&"
import script from "./sidebar-item-menu.vue?vue&type=script&lang=js&"
export * from "./sidebar-item-menu.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-item-menu.vue?vue&type=style&index=0&id=264ca18f&scoped=true&lang=css&"
import style1 from "./sidebar-item-menu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264ca18f",
  null
  
)

export default component.exports